import axios from './axiosInstances/axiosInstance';

export const validateBasket = (basketId) => {
  return axios.post(`/baskets/${basketId}/validate`);
};
